import type { MobilePlatform } from '../../RedirectToMobileApp';
import { AppStoreButton } from './app-store-button';
import { GoogleStoreButton } from './google-store-button';

export const usePlatformAssets = ({ platform }: { platform: MobilePlatform }) => {
  if (platform === 'android') {
    return {
      button: <GoogleStoreButton />,
      info: 'Click the Google Play button below to download the app.',
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  if (platform === 'ios') {
    return {
      additionalTitle: 'Click the “Get” button above',
      button: <AppStoreButton />,
      info: 'Or click the App Store button below to download the app.',
    };
  }

  return { button: null, info: 'Click the Install button in the top banner to download the app from the App Store.' };
};
